<div class="tooltip" [class.no-limit-width]="!limitedWidth">
  <ng-content></ng-content>
</div>
